const SPA_FALLBACK_QUERY_KEY = '__lantern_spa_path';

function cleanFallbackQuery(url: URL) {
  url.searchParams.delete(SPA_FALLBACK_QUERY_KEY);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export function restoreSpaFallbackPath() {
  const currentUrl = new URL(window.location.href);
  const fallbackPath = currentUrl.searchParams.get(SPA_FALLBACK_QUERY_KEY);

  if (!fallbackPath) return;

  const targetUrl = new URL(fallbackPath, window.location.origin);

  if (targetUrl.origin !== window.location.origin) {
    cleanFallbackQuery(currentUrl);
    return;
  }

  window.history.replaceState(window.history.state, '', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
}
